var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var BaseOutlierConfig_1;
import { Column } from '@symon-ai/wisepipe-common-data';
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { ColumnFormat, CustomFormat, DefaultSettings } from './customFormat';
import { ToolConfig } from './toolConfig';
import { ToolScopeBuilder } from './toolScopeBuilder';
import { ToolValidationResult } from './validation/toolValidationResult';
import { validateSourceWithDetail } from './validation/validateHelper';
import { baseOutlierConfigSchemaValidation } from '../validations.generated';
export const baseOutlierConfigSchema = {
    $id: 'urn:wisepipe-common-pipe:BaseOutlierConfig',
    type: 'object',
    properties: {
        column: { type: 'string', minLength: 1 },
        newColumn: { type: 'string', minLength: 1 },
        groupByColumns: {
            type: 'array',
            items: { type: 'string' },
            uniqueItems: true
        }
    },
    required: ['column']
};
let BaseOutlierConfig = BaseOutlierConfig_1 = class BaseOutlierConfig extends ToolConfig {
    constructor(toolType, column, newColumn, groupByColumns, customFormats) {
        super(toolType, customFormats);
        this.column = column;
        if (newColumn !== undefined)
            this.newColumn = newColumn;
        if (groupByColumns !== undefined)
            this.groupByColumns = groupByColumns;
        JSON.validate(this, BaseOutlierConfig_1);
    }
    // eslint-disable-next-line class-methods-use-this
    get in() {
        return BaseOutlierConfig_1.in;
    }
    // eslint-disable-next-line class-methods-use-this
    get out() {
        return BaseOutlierConfig_1.out;
    }
    // eslint-disable-next-line class-methods-use-this
    get ins() {
        return BaseOutlierConfig_1.ins;
    }
    // eslint-disable-next-line class-methods-use-this
    get outs() {
        return BaseOutlierConfig_1.outs;
    }
    static get in() {
        return BaseOutlierConfig_1.ins[0];
    }
    static get out() {
        return BaseOutlierConfig_1.outs[0];
    }
    static get ins() {
        return ['default'];
    }
    static get outs() {
        return ['default'];
    }
    getOutputForOutlier(ins, addProbability, probabilityColumnName) {
        const tsb = new ToolScopeBuilder(ins);
        const source = ins.schemas.at(this.in);
        if (source) {
            const exp = tsb.export(this.out);
            // groupby for outlier only is used in the calculation, its not used to "restrict" the which columns show up.  so even if you add
            // groupby columns, non-grpby cols still show up.
            const dependents = this.copyAllInsWithGroupby(exp, source, this.in, this.column, this.groupByColumns);
            const newColumnFormats = new Map();
            const newColumnName = this.newColumn === undefined ? 'Outlier' : this.newColumn;
            exp.makeNew(new Column(newColumnName, 'boolean'), dependents, true);
            if (addProbability) {
                const columnName = probabilityColumnName ?? `${newColumnName} Probability`;
                exp.makeNew(new Column(columnName, 'number'), dependents, true);
                newColumnFormats.set(columnName, new CustomFormat(ColumnFormat.Percentage, 0, DefaultSettings.thousandSeparator, true));
            }
            exp.initializeColumnFormats().setColumnFormats(newColumnFormats).setColumnFormats(this.customFormats);
        }
        return tsb.build();
    }
    getOutput(iConfigHelper, ins) {
        return this.getOutputForOutlier(ins, false);
    }
    isValidForCalc(iConfigHelper, scope) {
        const toolValidationResult = this.getToolValidationResult(iConfigHelper, scope);
        return toolValidationResult.validationState;
    }
    getToolValidationResult(iConfigHelper, scope) {
        const source = scope.schemas.at(this.in);
        if (!source) {
            return ToolValidationResult.getMissingSourceColumnsResult();
        }
        const inputs = new Map([[this.column, ['number']]]);
        this.addGroupByToInputs(inputs, this.groupByColumns);
        const outputs = [this.newColumn === undefined ? 'Outlier' : this.newColumn];
        const sourceValidationResult = validateSourceWithDetail(source, inputs, outputs);
        return ToolValidationResult.getResultFromSourceValidation(sourceValidationResult);
    }
};
BaseOutlierConfig = BaseOutlierConfig_1 = __decorate([
    JsonSchemaV2(baseOutlierConfigSchema, baseOutlierConfigSchemaValidation)
], BaseOutlierConfig);
export { BaseOutlierConfig };
//# sourceMappingURL=baseOutlierConfig.js.map